<template>
<v-container grid-list-xl fluid>
    <v-layout row wrap>
        <v-flex lg12>
            <v-card>
                <hpo-filter :headers="filter_headers" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
                <v-data-table fixed-header height="calc(100vh - 300px)"   :headers="headers" :items="items" :options.sync="pagination" :server-items-length="total_rows" :footer-props="items_per_page" :must-sort="true" :loading="loading" :mobile-breakpoint="100">
                    <template v-slot:header="{ props }"><table-header-filter :headers="props.headers" :viewName="viewName" v-on:applyFilter="applyFilter"></table-header-filter></template>
                    <template v-slot:item="{ item, index }">
                        <tr :id="'r-' + item.ID">
                            <td>{{ total_rows - index}}</td>
                            <td>{{ item.ID }}</td>
                            <td>{{ item.Username }}</td>
                            <td class="text-end">{{ item.NumberOfPack | currency }}</td>
                            <td class="text-end">{{ item.Weight | currency('', 2) }}</td>
                            <td class="text-end">{{ item.TotalAmount | currency }}</td>
                            <td v-bind:style="{ 'color': get_status_color(item.Status, receipt_status)}">
                                {{ item.Status | display_value(receipt_status) }}
                            </td>
                            <td>{{ item.CreatedDate | display_date('DD-MM-YYYY')}} <br /> {{ item.CreatedDate | display_date('HH:mm:ss')}} </td>
                            <td>{{ item.ExportDate | display_date('DD-MM-YYYY')}} <br /> {{ item.ExportDate | display_date('HH:mm:ss')}} </td>
                            <td>{{ item.Note }}</td>
                            <td class="text-center">
                                <v-icon medium class="ma-1" @click="gotoDetail(item)">fa-edit</v-icon>
                                <v-icon medium class="ma-1" @click="deleteItem(item.ID)" :disabled="!adminRole">fa-trash-alt</v-icon>
                            </td>
                        </tr>
                    </template>
                    <template v-slot:body.append v-if="summary">
                        <tr class="total-summary-td">
                            <td colspan="3" class="text-center font-weight-bold">Tổng</td>
                            <td class="text-end font-weight-bold">{{ summary.NumberOfPack | currency}}</td>
                            <td class="text-end font-weight-bold">{{ summary.Weight | currency('', 2) }}</td>
                            <td class="text-end font-weight-bold">{{ summary.TotalAmount | currency}}</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
        </v-flex>
    </v-layout>
    <v-dialog v-model="dialogReceipt" persistent fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="oee-theme">
            <v-btn icon dark @click="dialogReceipt = false">
              <v-icon>fa-times-circle</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-toolbar-title>Phiếu xuất kho #{{selectedItem.ID > 0 ? selectedItem.ID : 'Tạo mới'}}</v-toolbar-title>
        </v-toolbar>
        <v-card-actions>
            <div class="pl-4 red--text" v-if="!isApprovePayment">Khách hàng chưa được duyệt công nợ!</div>  
            <v-spacer></v-spacer>
            <v-btn color="red darken-1 white--text" class="mt-8 mr-2" @click="printDetail">In ấn</v-btn>
            <v-btn color="teal darken-1 white--text" class="mt-8 mr-2" @click="exportExcelDetail">Xuất file</v-btn>
            <v-btn color="green darken-1 white--text" class="mt-8 mr-2" v-if="selectedItem.Status == 0" @click="exportItem()" :disabled="!isApprovePayment">Xuất kho</v-btn>
            <!--<v-btn color="blue darken-1 white--text" class="mt-8 mr-4" @click="saveItem()">Cập nhật</v-btn>-->
        </v-card-actions>
        <v-card-text>
          <v-container grid-list-xl fluid>
            <v-layout row wrap>
                <v-flex lg3 md3 sm12 pa-0 pl-3>
                    <v-text-field label="Ngày tạo" :value="selectedItem.CreatedDate | display_date" readonly></v-text-field>
                </v-flex>
                <v-flex lg3 md3 sm12 pa-0 pl-3>
                    <v-autocomplete :rules="requireRules" :readonly="selectedItem.ID > 0" label="Khách hàng" v-model="selectedItem.UID" :items="customers" item-text="FilterName" item-value="ID" @change="onSelectCustomer" :disabled="selectedItem.ID > 0"></v-autocomplete>
                </v-flex>
                <v-flex lg3 md3 sm12 pa-0 pl-3>
                    <v-text-field label="Công nợ" :value="selectedCustomerDebt | currency" readonly></v-text-field>
                </v-flex>
                <v-flex lg3 md3 sm12 pa-0 pl-2>
                    <v-autocomplete label="Địa chỉ nhận" v-model="selectedAddressID" :items="addressBooks" item-text="Receiver" item-value="ID" @change="onSelectAddress"></v-autocomplete>
                </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex lg3 md3 sm12 pa-0 pl-3>
                    <v-autocomplete readonly label="Chăm sóc khách hàng" v-model="selectedCSID" :items="staffs" item-text="FullName" item-value="ID"></v-autocomplete>
                </v-flex>
                <v-flex lg3 md3 sm12 pa-0 pl-2 pt-8 v-if="selectedCSPhone">
                    Liên hệ Zalo: <a target="blank" :href="'https://zalo.me/' + selectedCSPhone">{{ selectedCSPhone }}</a>
                </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex lg3 md3 sm12 v-if="selectedItem.Status == 0">
                    <v-text-field label="Mã bill" ref="trancode" v-model="newTransactionCode" @keydown.enter="appendPackageItem(false)" :disabled="!selectedItem.UID || (selectedItem.Status == 1 && selectedItem.ID > 0)"></v-text-field>
                </v-flex>
                <v-flex lg3 md3 sm12 v-if="selectedItem.Status == 0">
                    <v-text-field label="Mã bao hàng" ref="bigcode" v-model="bigpackageCode" @keydown.enter="appendBigPackage()" :disabled="!selectedItem.UID || (selectedItem.Status == 1 && selectedItem.ID > 0)"></v-text-field>
                </v-flex>
                <v-flex lg12 md12 sm12 class="d-flex align-center">
                    <v-btn color="blue darken-1 white--text" @click="appendAllCustomerPackages" :disabled="!selectedItem.UID" v-if="selectedItem.Status == 0">
                        Nạp tất cả bill đã nhập kho VN
                    </v-btn>
                    <v-btn color="red darken-1 white--text" class="ml-2" @click="deleteSelectedPackages" :disabled="!selectedPackages || selectedPackages.length == 0 || (selectedItem.Status == 1 && selectedItem.ID > 0 && !adminRole)">
                        <v-icon left small class="mr-1">fa-trash-alt</v-icon>
                        Xóa mục đã chọn ({{ selectedPackages ? selectedPackages.length : 0 }})
                    </v-btn>
                </v-flex>
                <v-flex lg12 md12 sm12 xs12>
                    <span style="color: red">{{internalMessage}}</span>
                </v-flex>
                <v-flex lg12 pt-0>
                    <v-card>
                        <v-data-table fixed-header height="450px" :headers="package_headers" :items="orderTransactions" :options.sync="package_pagination" :server-items-length="orderTransactions ? orderTransactions.length : 0" :footer-props="{'items-per-page-options': [-1]}" :must-sort="true" :mobile-breakpoint="100" show-select v-model="selectedPackages" item-key="ID">
                            <template v-slot:item="{ item, index, isSelected, select }">
                                <tr :active="isSelected" :id="'r-' + item.ID">
                                    <td @click.stop="select(!isSelected)">
                                        <v-simple-checkbox :value="isSelected" @input="select($event)" hide-details color="primary"></v-simple-checkbox>
                                    </td>
                                    <td>{{ (orderTransactions ? orderTransactions.length : 0) - index }}</td>
                                    <td>{{ item.TransactionCode }}</td>
                                    <td>{{ item.StoreVNImportDate | display_date }}</td>
                                    <td class="text-end">{{ item.Weight | currency('', 2) }}</td>
                                    <td class="text-end">{{ item.RealNumberOfPack | currency }}</td>
                                    <td class="text-end">{{ item.TotalWeight | currency('', 2) }}</td>
                                    <td class="text-right">{{ item.TotalAmount | currency }}</td>
                                    <td v-bind:style="{ 'color': get_status_color(item.Status, package_status)}">{{ item.Status | display_value(package_status) }}</td>
                                    <td>{{ item.OrderNote }}</td>
                                    <td class="text-center">
                                        <v-icon medium @click="deletePackageItem(item)" :disabled="selectedItem.Status == 1 && selectedItem.ID > 0 && !adminRole">fa-trash-alt</v-icon>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-card>
                </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex lg3 md3 sm12>
                <h-currency-input v-model="selectedItem.WeightPrice" label="Giá cân" :decimal="0" readonly></h-currency-input>
              </v-flex>
              <v-flex lg3 md3 sm12>
                <h-currency-input v-model="selectedItem.Weight" label="Tổng cân" :decimal="2" readonly></h-currency-input>
              </v-flex>
              <v-flex lg3 md3 sm12>
                <h-currency-input v-model="selectedItem.TotalAmount" label="Tổng tiền" :decimal="0" readonly></h-currency-input>
              </v-flex>
              <v-flex lg3 md3 sm12>
                <h-currency-input v-model="selectedItem.NumberOfPack" label="Số kiện" :decimal="0" readonly></h-currency-input>
              </v-flex>
              <v-flex lg3 md3 sm12>
                <v-select :rules="requireRules" label="Kho VN" v-model="selectedItem.VNStoreID" :items="vnstores" item-text="Name" item-value="ID"></v-select>
              </v-flex>
              <v-flex lg3 md3 sm12>
                <v-text-field label="Hình thức ship" v-model="selectedItem.ShippingMethod"></v-text-field>
              </v-flex>
              <v-flex lg3 md3 sm12>
                <v-text-field label="Người nhận" v-model="selectedItem.Receiver"></v-text-field>
              </v-flex>
              <v-flex lg3 md3 sm12>
                <v-text-field label="Điện thoại" v-model="selectedItem.Phone"></v-text-field>
              </v-flex>
              <v-flex lg12 md12 sm12>
                <v-text-field label="Địa chỉ" v-model="selectedItem.Address"></v-text-field>
              </v-flex>
               <v-flex lg4 md4 sm12>
                <v-text-field label="Đơn vị vận chuyển" v-model="selectedItem.Shipper"></v-text-field>
              </v-flex>
               <v-flex lg4 md4 sm12>
                <v-text-field label="Ghi chú nội bộ" v-model="selectedItem.Note"></v-text-field>
              </v-flex>
               <v-flex lg4 md4 sm12>
                <v-text-field label="Ghi chú khách hàng" v-model="selectedItem.NoteForCustomer"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
</v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "@/configs";
import Filtering from "@/components/Filtering";
import { sendErrorNotice, sendSuccessNotice, refreshResource, isMobileAgent, playSound } from '@/commons/utils';
import { request_header, request_list, print_export_receipt_order, print_export_receipt_deposit, update_detail } from '@/commons/hpod';
import Vue from 'vue';
import _ from "lodash";
import FileSaver from 'file-saver';
import moment from 'moment';

export default {
    components: {
        "hpo-filter": Filtering
    },
    props: ["uId"],
    data() {
        return {
            headers: [
                {
                    text: "STT",
                    value: "index"
                },
                {
                    text: "Mã phiếu",
                    value: "ID",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Khách hàng",
                    value: "Username",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Số kiện",
                    value: "NumberOfPack",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Tổng cân",
                    value: "Weight",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Tổng tiền",
                    value: "TotalAmount",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Trạng thái",
                    value: "Status",
                    filterable: true,
                    values: configs.EXPORT_RECEIPT_STATUS,
                    dataType: configs.DATA_TYPE["Enum"]
                },
                {
                    text: "Ngày tạo",
                    value: "CreatedDate",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Date"]
                },
                {
                    text: "Ngày xuất",
                    value: "ExportDate",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Date"]
                },
                {
                    text: "Ghi chú",
                    value: "Note",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                },                
                {
                    text: "Thao tác",
                    value: "",
                    align: "center",
                    sortable: false,
                    filterable: false,
                    width: "100px"
                }
            ],
            package_headers: [
                {
                    text: "STT",
                    value: "index"
                },
                {
                    text: "Mã bill",
                    value: "TransactionCode",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Ngày nhập kho VN",
                    value: "StoreVNImportDate",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Date"]
                },
                {
                    text: "Cân nặng",
                    value: "Weight",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Số lượng",
                    value: "RealNumberOfPack",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Tổng cân",
                    value: "TotalWeight",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Thành tiền",
                    value: "TotalAmount",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Trạng thái",
                    value: "Status",
                    filterable: true,
                    values: configs.PACKAGE_STATUS,
                    dataType: configs.DATA_TYPE["Enum"]
                },
                {
                    text: "Ghi chú",
                    value: "OrderNote",
                    filterable: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Thao tác",
                    value: "",
                    align: "center",
                    sortable: false,
                    filterable: false
                }
            ],
            dialogReceipt: false,
            useInternalCode: false,
            package_status: configs.PACKAGE_STATUS,
            receipt_status: configs.EXPORT_RECEIPT_STATUS,
            order_type_list: configs.ORDER_TYPE_LIST,
            pagination: {  ...configs.PAGINATION,  sortBy: ["ID"]  },
            package_pagination: {  ...configs.PAGINATION,  sortBy: ["StoreVNImportDate"], itemsPerPage: -1 },
            items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
            viewName: "exportreceipt_list",
            filterConditions: [],
            quickFilterConditions: [],
            requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
            selectedItem: {
                ID: 0,
                UID: 0,
                Status: 0,
                VNStoreID: 1,
                NumberOfPack: 0,
                Weight: 0,
                Volume: 0,
                FeeShipVND: 0,
                TotalAmount: 0,
                WeightPrice: 0,
                ShippingMethod: '',
                Receiver: '',
                Phone: '',
                Address: '',
                Shipper: '',
                Note: '',
                NoteForCustomer: ''
            },
            newTransactionCode: '',
            newTransactionCodeVN: '',
            isApprovePayment: true,
            internalMessage: '',
            isDepositOrder: configs.SYSTEM_TYPE != 'order',
            bigpackageCode: '',
            selectedAddressID: 0,
            selectedCSID: 0,
            selectedCSPhone: '',
            selectedAddress: {},
            selectedPackages: [],
        };
    },
    watch: {
        pagination: {
            handler: function (val, oldVal) {
                let filterConditions = this.$store.state.commons.filterConditions;
                this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
                this.filter_data();
            },
            deep: true
        },
        items() {
            if(this.dialogReceipt && this.selectedItem.ID && this.items && this.items.length > 0) {
                let item = _.find(this.items, {'ID': this.selectedItem.ID});
                if(item !== undefined) {
                    this.selectedItem = item;
                }
            }
        },
        product_type_list() {
            let header_item = _.find(this.package_headers, { value: "ProductType" });
            if (header_item) {
                header_item.values = this.product_type_list;
            }
        },
        selectedItem: {
            handler: function (val, oldVal) {
                if(val.ID > 0 && oldVal.ID == 0) {
                    this.getTransactionOfReceipt();
                }
                if(this.selectedItem.UID > 0) {
                    this.$store.dispatch("addressBook/getList", {
                        filter: [{
                            column: "UID",
                            value: this.selectedItem.UID,
                            condition: "equal"
                        }]
                    });
                    let customer = _.find(this.customers, { ID: this.selectedItem.UID });
                    this.selectedCSID= customer.CustomerServiceID;
                    this.isApprovePayment = (customer.IsApprovePayment && (customer.MaxDebt + customer.Wallet) >= 0) || (!customer.IsApprovePayment && customer.Wallet >= 0) || configs.SYSTEM_TYPE == 'order';
                }
            },
            deep: true
        },
        dialogReceipt() {
            if(!this.dialogReceipt){
                this.$store.commit("orderTransaction/setList", {data: []});
            }
            this.selectedPackages = [];
            this.isApprovePayment = true;
            this.internalMessage = '';
            this.newTransactionCode = '';
            this.bigpackageCode = '';
            this.selectedAddressID = 0;
            this.selectedAddress = {};
            let first_store = this.vnstores && this.vnstores.length > 0 ? this.vnstores[0] : {ID: 0, Name: ""};
            this.selectedItem.VNStoreID = first_store.ID;
        },
        orderTransactions: {
            handler() {
                if(this.dialogReceipt) {
                    this.syncReceiptSummary();
                }
            },
            deep: true
        },
        selectedCSID() {
            let staff = _.find(this.staffs, { ID: this.selectedCSID });
            this.selectedCSPhone= staff.PhoneNumber;
        }
    },
    computed: {
        ...mapState({
            items: state => state.exportReceipt.all.data,
            total_rows: state => state.exportReceipt.all.total,
            currentItem: state => state.exportReceipt.selected,
            summary: state => state.exportReceipt.all.summary,
            loading: state => state.exportReceipt.loading,
            orderTransactions: state => state.orderTransaction.all.data,
            vnstores: state => state.commons.stores,
            chinaStores: state => state.commons.chinaStores,
            configuration: state => state.configuration.selected,
            staffs: state => state.commons.all_users,
            customers: state => _.map(state.customer.master.data, (item) => {
                return {
                    ...item,
                    'FilterName': item.CustomerCode ? item.CustomerCode : item.Username
                }
            }),
            addressBooks: state => state.addressBook.all.data,
        }),
        selectedCustomerDebt() {
            if (this.selectedItem && this.selectedItem.UID > 0 && this.customers) {
                const customer = _.find(this.customers, { ID: this.selectedItem.UID });
                return customer ? (customer.Debt || 0) : 0;
            }
            return 0;
        },
        isMobile: isMobileAgent,
        adminRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
        },
        tableConfig() {
            let params = {
                pagination: this.pagination,
                filter: [...this.filterConditions],
                quickFilter: [...this.quickFilterConditions]
            };
            if (this.uId > 0) {
                params.filter.push({
                    column: "UID",
                    value: this.uId,
                    condition: "equal"
                });
                params.filter.push({
                    column: "Status",
                    value: 1,
                    condition: "equal"
                });
            }
            return params;
        },
        product_type_list() {
            return this.configuration.ProductTypes ? JSON.parse(this.configuration.ProductTypes) : [];
        },
        filter_headers() {
            return this.headers;
        },
    },
    methods: {
        filter_data: function () {
            this.$store.dispatch("exportReceipt/getList", this.tableConfig);
            if(this.dialogReceipt) {
                this.getTransactionOfReceipt();
            }
        },
        applyFilter(filterConditions) {
            let sortBy = this.pagination.sortBy
            let sortDesc = this.pagination.sortDesc
            this.pagination = configs.PAGINATION;
            this.pagination.sortBy = sortBy;
            this.pagination.sortDesc = sortDesc;
            this.filterConditions = filterConditions;
            this.filter_data();
        },
        quickFilter(filterConditions) {
            this.quickFilterConditions = filterConditions;
            this.filter_data();
        },
        get_status_color(val, enums) {
            return this.$options.filters.display_color(val, enums);
        },
        getCustomerList() {
            this.$store.dispatch("customer/getCustomerList", {
                is_master: 1,
                fields: ["ID", "Username", "CustomerCode", "Address", "PhoneNumber", "FirstName", "LastName", "CustomerServiceID", "IsApprovePayment", "ChinaStoreID", "ReceivePlaceID", "Wallet", "MaxDebt", "Debt"]
            });
        },
        getTransactionOfReceipt() {
            this.selectedPackages = [];
            if(this.selectedItem.ID > 0) {
                var param={
                    pagination: this.package_pagination,
                    filter: [
                    {
                        column: "ReceiptID",
                        value: this.selectedItem.ID,
                        condition: "equal"
                    }
                    ]
                };
                this.$store.dispatch("orderTransaction/getList", param);
            }            
        },
        focusTransactionCode() {
            this.$nextTick(() => {
                if(this.$refs.trancode) {
                    this.$refs.trancode.focus();
                }
            });
        },
        syncReceiptSummary() {
            const numberOfPack = _.sumBy(this.orderTransactions, item => Number(item.RealNumberOfPack || item.NumberOfPack) || 1);
            const weight = _.sumBy(this.orderTransactions, item => Number(item.TotalWeight || item.Weight) || 0);
            const volume = _.sumBy(this.orderTransactions, item => Number(item.TotalVolume || item.Volume) || 0);
            const feeShipVND = _.sumBy(this.orderTransactions, item => Number(item.FeeShipVND) || 0);
            const totalAmount = _.sumBy(this.orderTransactions, item => Number(item.TotalAmount) || Number(item.FeeShipVND) || 0);

            let weightPrice = this.selectedItem.WeightPrice || 0;
            if (this.orderTransactions && this.orderTransactions.length > 0) {
                const firstTransactionWithPrice = _.find(this.orderTransactions, item => Number(item.WeightPrice) > 0);
                if (firstTransactionWithPrice) {
                    weightPrice = Number(firstTransactionWithPrice.WeightPrice);
                } else if (this.selectedItem.UID > 0 && this.customers) {
                    const customer = _.find(this.customers, { ID: this.selectedItem.UID });
                    if (customer && Number(customer.FeeWeight) > 0) {
                        weightPrice = Number(customer.FeeWeight);
                    }
                }
            }

            this.$set(this.selectedItem, 'NumberOfPack', numberOfPack);
            this.$set(this.selectedItem, 'Weight', weight);
            this.$set(this.selectedItem, 'Volume', volume);
            this.$set(this.selectedItem, 'FeeShipVND', feeShipVND);
            this.$set(this.selectedItem, 'TotalAmount', totalAmount);
            this.$set(this.selectedItem, 'WeightPrice', weightPrice);
        },
        fetchTransactions(param) {
            return new Promise((resolve) => {
                request_list('order_transactions', ret => {
                    resolve(ret.data || []);
                }, Vue.http, param, this.$store.state.authentication.token);
            });
        },
        assignTransactionsToReceipt(transactions) {
            if(!(this.selectedItem.ID > 0) || !transactions || transactions.length == 0) {
                return Promise.resolve();
            }
            return Promise.all(_.map(transactions, transaction => {
                return new Promise((resolve) => {
                    update_detail('order_transactions', () => {
                        resolve();
                    }, Vue.http, {
                        ID: transaction.ID,
                        ReceiptID: this.selectedItem.ID,
                        Status: configs.PACKAGE_STATUS_ENUM.DA_VE_VN,
                        ModifiedBy: this.$store.state.authentication.user.username
                    }, transaction.ID, this.$store.state.authentication.token);
                });
            }));
        },
        validateReceiptTransaction(transaction) {
            if(Number(transaction.Weight) <= 0) {
                return 'Mã bill chưa nhập cân nặng.';
            }
            if(transaction.UID && this.selectedItem.UID > 0 && transaction.UID != this.selectedItem.UID) {
                return 'Mã bill không thuộc khách hàng của phiếu xuất.';
            }
            if(transaction.Status != configs.PACKAGE_STATUS_ENUM.DA_VE_VN) {
                return 'Mã bill chưa ở trạng thái đã nhập kho VN.';
            }
            if(transaction.ReceiptID > 0 && transaction.ReceiptID != this.selectedItem.ID) {
                return `Mã bill đã tồn tại trong phiếu ${transaction.ReceiptID}.`;
            }
            return '';
        },
        normalizeReceiptTransactions(transactions) {
            let existedCodes = _.map(this.orderTransactions, 'TransactionCode');
            let validTransactions = [];
            let skippedCodes = [];
            let errorMessages = [];
            let customer = _.find(this.customers, { ID: this.selectedItem.UID });

            _.forEach(transactions, transaction => {
                if(_.includes(existedCodes, transaction.TransactionCode)) {
                    skippedCodes.push(transaction.TransactionCode);
                    return;
                }
                const errorMessage = this.validateReceiptTransaction(transaction);
                if(errorMessage) {
                    errorMessages.push(`#${transaction.TransactionCode}: ${errorMessage}`);
                    return;
                }
                let feeWeight = (transaction.WeightPrice && Number(transaction.WeightPrice) > 0) ? Number(transaction.WeightPrice) : (customer && Number(customer.FeeWeight) > 0 ? Number(customer.FeeWeight) : 0);
                if ((!transaction.TotalAmount || Number(transaction.TotalAmount) === 0) && Number(transaction.Weight) > 0 && feeWeight > 0) {
                    transaction.WeightPrice = feeWeight;
                    transaction.TotalAmount = Math.ceil(Number(transaction.Weight) * feeWeight) + (Number(transaction.FeeShipVND) || 0);
                }
                validTransactions.push(transaction);
            });

            return {
                validTransactions,
                skippedCodes,
                errorMessages
            };
        },
        onSelectAddress() {
            this.selectedAddress = _.find(this.addressBooks, {ID: this.selectedAddressID});
            if (this.selectedAddress) {
                this.selectedItem.Receiver = this.selectedAddress.Receiver || this.selectedItem.Receiver;
                this.selectedItem.Phone = this.selectedAddress.Phone || this.selectedItem.Phone;
                this.selectedItem.Address = this.selectedAddress.Address || this.selectedItem.Address;
            }
        },
        onSelectCustomer() {
            let customer = _.find(this.customers, {
                ID: this.selectedItem.UID
            });
            if(customer) {
                this.selectedItem.Username = customer.CustomerCode || customer.Username;
                const fullName = [customer.LastName, customer.FirstName].filter(Boolean).join(' ').trim();
                this.selectedItem.Receiver = fullName || customer.Username || '';
                this.selectedItem.Address = customer.Address || '';
                this.selectedItem.Phone = customer.PhoneNumber || '';
                this.selectedCSID= customer.CustomerServiceID;
                if(_.find(this.vnstores, {ID: customer.ReceivePlaceID})) {
                    this.selectedItem.VNStoreID = customer.ReceivePlaceID;
                }
                this.isApprovePayment = (customer.IsApprovePayment && (customer.MaxDebt + customer.Wallet) >= 0) || (!customer.IsApprovePayment && customer.Wallet >= 0) || configs.SYSTEM_TYPE == 'order';
            }
            this.$store.commit("orderTransaction/setList", {data: [], total: 0});
            if (this.selectedItem.UID) {
                this.$store.dispatch("addressBook/getList", {
                    filter: [{
                        column: "UID",
                        value: this.selectedItem.UID,
                        condition: "equal"
                    }]
                });
            }
            else {
                this.addressBooks = [];
                this.selectedAddressID = null;
            }
        },
        appendBigPackage() {
            this.$store.dispatch("bigPackage/receiptExportCode", {
                data: { 'ExportCode': this.bigpackageCode, 'ReceiptID': this.selectedItem.ID }
            }).then((ret) => {
                if(ret.status == 200 && ret.data.length > 0) {
                    const normalizedTransactions = this.normalizeReceiptTransactions(ret.data);
                    if(normalizedTransactions.validTransactions.length == 0) {
                        playSound('/oee-error.mp3');
                        sendErrorNotice(normalizedTransactions.errorMessages[0] || 'Không có mã bill hợp lệ để thêm vào phiếu xuất.');
                        return;
                    }
                    if(normalizedTransactions.errorMessages.length > 0) {
                        sendErrorNotice(normalizedTransactions.errorMessages[0]);
                    }
                    this.orderTransactions.push(...normalizedTransactions.validTransactions);
                    this.syncReceiptSummary();
                    this.bigpackageCode = '';
                    if(this.selectedItem.ID > 0) {
                        this.saveItem();
                    }
                    refreshResource();
                }
            });
            this.$nextTick(() => this.$refs.bigcode.focus());
            
        },
        async appendPackageItem(isInternalCode = false) {
            let existedItem = false;
            if(!isInternalCode) {
                this.newTransactionCode = this.newTransactionCode.trim();
                existedItem = _.find(this.orderTransactions, {'TransactionCode': this.newTransactionCode});
            }
            else {
                this.newTransactionCodeVN = this.newTransactionCodeVN.trim();
                existedItem = _.find(this.orderTransactions, {'TransactionCodeVN': this.newTransactionCodeVN});
            }
            
            if(existedItem) {
                playSound('/oee-error.mp3');
                sendErrorNotice('Mã bill đã có trong phiếu xuất kho.');
                return;
            }

            var param = {
                filter: [
                {
                    column: "Status",
                    value: configs.PACKAGE_STATUS_ENUM.DA_VE_VN,
                    condition: "equal"
                }
                ]
            };

            if(!isInternalCode) {
                param.filter.push({
                    column: "TransactionCode",
                    value: this.newTransactionCode,
                    condition: "s_equal"
                })
            }
            else { 
                param.filter.push({
                    column: "TransactionCodeVN",
                    value: this.newTransactionCodeVN,
                    condition: "s_equal"
                })
            }

            request_list('order_transactions', async ret => {
                if(!isInternalCode && ret.data.length > 1) {
                    this.internalMessage = `Mã tách ${this.newTransactionCode} gồm ${ret.data.length} kiện.` ;
                }
                else if(!isInternalCode && ret.data.length <= 1) {
                    this.internalMessage = ''; 
                    this.useInternalCode = false;
                }
                if(ret.data.length == 1) {
                    const normalizedTransactions = this.normalizeReceiptTransactions(ret.data);
                    if(normalizedTransactions.validTransactions.length == 0) {
                        playSound('/oee-error.mp3');
                        sendErrorNotice(normalizedTransactions.errorMessages[0] || 'Mã bill không hợp lệ.');
                        return;
                    }
                    const itemToAdd = normalizedTransactions.validTransactions[0];
                    if(this.selectedItem.ID > 0) {
                        await this.assignTransactionsToReceipt([itemToAdd]);
                    }
                    sendSuccessNotice(`Đã thêm mã bill #${itemToAdd.TransactionCode} vào phiếu xuất.`);
                    this.orderTransactions.push(itemToAdd);
                    this.syncReceiptSummary();
                    if(this.selectedItem.ID > 0) {
                        this.saveItem();
                    }
                    this.newTransactionCode = '';
                    this.focusTransactionCode();
                }
                else if(ret.data.length > 1) {
                    this.useInternalCode = true;
                }
                else {
                    playSound('/oee-error.mp3');
                    sendErrorNotice('Mã bill không tồn tại hoặc chưa nhập kho.');
                }
            }, Vue.http, param, this.$store.state.authentication.token);
        },
        async appendAllCustomerPackages() {
            if(!this.selectedItem.UID) {
                sendErrorNotice('Hãy chọn khách hàng trước khi nạp danh sách mã bill.');
                return;
            }
            this.$store.commit("orderTransaction/setList", {data: []});
            const transactions = await this.fetchTransactions({
                pagination: { ...configs.PAGINATION, itemsPerPage: 10000, sortBy: ['StoreVNImportDate'], sortDesc: [true] },
                filter: [
                    {
                        column: 'UID',
                        value: this.selectedItem.UID,
                        condition: 'equal'
                    },
                    {
                        column: 'Status',
                        value: configs.PACKAGE_STATUS_ENUM.DA_VE_VN,
                        condition: 'equal'
                    }
                ],
                quickFilter: []
            });

            const normalizedTransactions = this.normalizeReceiptTransactions(transactions);
            if(normalizedTransactions.validTransactions.length == 0) {
                playSound('/oee-error.mp3');
                sendErrorNotice(normalizedTransactions.errorMessages[0] || 'Không có mã bill hợp lệ để nạp vào phiếu xuất.');
                return;
            }

            if(this.selectedItem.ID > 0) {
                await this.assignTransactionsToReceipt(normalizedTransactions.validTransactions);
            }

            this.orderTransactions.push(...normalizedTransactions.validTransactions);
            this.syncReceiptSummary();
            if(this.selectedItem.ID > 0) {
                this.saveItem();
            }

            if(normalizedTransactions.errorMessages.length > 0 || normalizedTransactions.skippedCodes.length > 0) {
                const skippedMessage = normalizedTransactions.skippedCodes.length > 0 ? `Bỏ qua bill đã có sẵn: ${normalizedTransactions.skippedCodes.join(', ')}.` : '';
                sendSuccessNotice(`Đã nạp ${normalizedTransactions.validTransactions.length} mã bill vào phiếu xuất. ${skippedMessage}`.trim());
            }
            else {
                sendSuccessNotice(`Đã nạp ${normalizedTransactions.validTransactions.length} mã bill vào phiếu xuất.`);
            }
            this.focusTransactionCode();
        },
        deletePackageItem(transaction) {
            if(this.selectedPackages && this.selectedPackages.length > 0) {
                this.selectedPackages = _.reject(this.selectedPackages, item => item.ID === transaction.ID);
            }
            if(this.selectedItem.ID > 0) {
                this.$store.dispatch("orderTransaction/setDetail", {
                    data: { 'ReceiptID': 0, 'ID': transaction.ID },
                    id: transaction.ID
                }).then(() => {
                    this.$store.commit('orderTransaction/removeFromList', transaction);
                    this.syncReceiptSummary();
                    this.saveItem();
                });
            }
            else {
                this.$store.commit('orderTransaction/removeFromList', transaction);
                this.syncReceiptSummary();
            }
            this.focusTransactionCode();
        },
        deleteSelectedPackages() {
            if (!this.selectedPackages || this.selectedPackages.length === 0) {
                return;
            }
            const itemsToDelete = [...this.selectedPackages];
            if (this.selectedItem.ID > 0) {
                Promise.all(_.map(itemsToDelete, transaction => {
                    return this.$store.dispatch("orderTransaction/setDetail", {
                        data: { 'ReceiptID': 0, 'ID': transaction.ID },
                        id: transaction.ID
                    });
                })).then(() => {
                    _.forEach(itemsToDelete, transaction => {
                        this.$store.commit('orderTransaction/removeFromList', transaction);
                    });
                    this.syncReceiptSummary();
                    this.saveItem();
                    this.selectedPackages = [];
                    sendSuccessNotice(`Đã xóa ${itemsToDelete.length} mã bill đã chọn khỏi phiếu xuất.`);
                    this.focusTransactionCode();
                });
            } else {
                _.forEach(itemsToDelete, transaction => {
                    this.$store.commit('orderTransaction/removeFromList', transaction);
                });
                this.syncReceiptSummary();
                this.selectedPackages = [];
                sendSuccessNotice(`Đã xóa ${itemsToDelete.length} mã bill đã chọn khỏi danh sách.`);
                this.focusTransactionCode();
            }
        },
        createData() {
            let first_store = this.vnstores && this.vnstores.length > 0 ? this.vnstores[0] : {ID: 1, Name: ""};
            this.selectedItem = {
                ID: 0,
                UID: 0,
                Status: 0,
                VNStoreID: first_store.ID,
                NumberOfPack: 0,
                Weight: 0,
                Volume: 0,
                FeeShipVND: 0,
                TotalAmount: 0,
                WeightPrice: 0,
                ShippingMethod: '',
                Receiver: '',
                Phone: '',
                Address: '',
                Shipper: '',
                Note: '',
                NoteForCustomer: ''
            };
            this.selectedPackages = [];
            this.$store.commit("orderTransaction/setList", {data: [], total: 0});
            this.dialogReceipt = true;
        },
        gotoDetail(item) {
            this.selectedPackages = [];
            this.selectedItem = item;
            this.getTransactionOfReceipt();
            this.dialogReceipt = true;
        },
        printDetail() {
            const frame_printing = configs.SYSTEM_TYPE == 'order' ?  print_export_receipt_order({...this.selectedItem, Voter: this.$store.state.authentication.user.fullname}, this.orderTransactions, true) : print_export_receipt_deposit({...this.selectedItem, Voter: this.$store.state.authentication.user.fullname}, this.orderTransactions, true);
            var doc = document.getElementById('print_frame').contentWindow.document;
            doc.open();
            doc.write(frame_printing);
            doc.close();
            setTimeout(function(){ window.frames["print_frame"].window.print(); }, 1000);
        },
        deleteItem(id) {
            window.getApp.$emit('REQUEST_DELETE_DATA', id);
        },
        exportItem(){
            if(!this.orderTransactions || this.orderTransactions.length == 0) {
                sendErrorNotice('Phiếu xuất chưa có mã vận đơn.');
                return;
            }
            this.selectedItem.Status = 1;
            // this.selectedItem.Action = 'export';
            this.saveItem();
        },
        saveItem(extraData = {}) {
            if(extraData && extraData.isTrusted !== undefined) {
                extraData = {};
            }
            if(!this.selectedItem.UID) {
                sendErrorNotice('Hãy chọn thông tin khách hàng trước khi lưu.')
                return;
            }
            this.selectedItem.OrderType = configs.SYSTEM_TYPE == 'order' ? configs.ORDER_TYPE.order : configs.ORDER_TYPE.deposit;
            const packageIds = _.map(this.orderTransactions, (item) => {return item.ID});
            this.$store.dispatch("exportReceipt/setDetail", {
                data: {
                    ...this.selectedItem,
                    ...extraData,
                    NumberOfPack: _.sumBy(this.orderTransactions, item => Number(item.RealNumberOfPack || item.NumberOfPack) || 1),
                    Packages: !this.selectedItem.ID ? packageIds : null
                },
                id: this.selectedItem.ID
            }).then((ret) => {
                if(this.selectedItem.ID == 0) {
                    this.selectedItem = {...this.currentItem};
                }
            });
        },
        exportExcel() {
            this.$store.dispatch("exportReceiptList/export", this.tableConfig);
        },
        exportExcelDetail() {
            if (!this.orderTransactions || this.orderTransactions.length === 0) {
                sendErrorNotice('Phiếu xuất chưa có mã vận đơn.');
                return;
            }

            const receiptId = this.selectedItem.ID > 0 ? this.selectedItem.ID : 'Moi';
            const requestOptions = {
                headers: request_header(this.$store.state.authentication.token),
                responseType: 'blob'
            };
            const api = configs.SYSTEM_TYPE == 'order' ? configs.API : configs.API_DEPOSIT;

            this.$store.commit('exportReceipt/setLoading', { loading: true });
            Vue.http.post(`${api}/admin/api/export_receipt/export-detail/`, {
                Receipt: this.selectedItem,
                Packages: this.orderTransactions
            }, requestOptions).then((response) => {
                const blob = new Blob([response.data], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                });
                FileSaver.saveAs(blob, `PhieuXuatKho_${receiptId}_${moment().format('YYYYMMDD_HHmmss')}.xlsx`);
                this.$store.commit('exportReceipt/setLoading', { loading: false });
            }, () => {
                this.$store.commit('exportReceipt/setLoading', { loading: false });
                sendErrorNotice('Không thể xuất file phiếu xuất kho.');
            });
        }
    },
    mounted() {
        this.$store.dispatch("configuration/getDetail", 1);
        this.getCustomerList();
        this.$store.dispatch("commons/getAllUsers");
        this.$store.dispatch("commons/getAllStores");
        this.$store.dispatch("commons/getAllChinaStores");
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_CREATE_DATA", this.createData);
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$on("REQUEST_EXPORT_EXCEL", this.exportExcel);
        this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
            this.$store.dispatch("exportReceipt/removeDetail", id);
            setTimeout(this.filter_data, 200);
        });
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_CREATE_DATA", this.createData);
        this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$off("REQUEST_EXPORT_EXCEL", this.exportExcel);
        this.$root.$off("CONFIRMED_REMOVE_DATA");
    }
};
</script>
